export enum AssignmentStatus {
  New = 'New',
  Active = 'Active',
  InReview = 'InReview',
  Completed = 'Completed',
  Pending = 'Pending',
  Overdue = 'Overdue',
  Reviewed = 'Reviewed',
}
